import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogPanel,
} from "@/client/components/ui/dialog";
import { ActivityEditForm } from "@/client/components/admin/ActivityEditForm";

/**
 * The activity editor as a dialog (the primary UX, opened from the Aanbod list's
 * "Bewerken" button). The long form lives inside a scrollable DialogPanel; its own
 * Sluiten/Opslaan controls sit at the bottom of the form, so the dialog adds no footer.
 *
 * - `programmeId` — which activity to edit; null keeps the dialog closed.
 * - `onClose`     — close the dialog (also fired on backdrop/escape).
 * - `onSaved`     — refresh the list after a successful save (we leave the dialog open so
 *                   the "Opgeslagen" confirmation is visible; the user closes when ready).
 */
export function ActivityEditDialog({
  programmeId, onClose, onSaved,
}: {
  programmeId: string | null;
  onClose: () => void;
  onSaved?: () => void;
}) {
  const open = programmeId != null;
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Activiteit bewerken</DialogTitle>
          <DialogDescription>
            Pas hier de volledige configuratie van deze activiteit aan. Alle velden zijn vooraf ingevuld.
          </DialogDescription>
        </DialogHeader>
        <DialogPanel>
          {/* Keyed remount so the form reloads fresh state for each opened activity. */}
          {programmeId != null && (
            <ActivityEditForm
              key={programmeId}
              programmeId={programmeId}
              onClose={onClose}
              onSaved={onSaved}
            />
          )}
        </DialogPanel>
      </DialogContent>
    </Dialog>
  );
}
